import { servicePost } from "./client.ts";
import { batchedServicePost } from "./readBatch.ts";
import type { ReturnObject } from "../types/returnObject.ts";

/* ── Types ─────────────────────────────────────────────── */

export interface SCategory {
  CategoryID: number;
  CategoryName: string;
  DisplayOrder: number;
}

export interface AccessCategory {
  CategoryID: number;
  CategoryName: string;
  DisplayOrder: number;
  OperatorID: number;
  ForceHand: boolean;
  ForceFlex: boolean;
  ForceLoft: boolean;
  CategoryImage?: string;
}

/* ── Standard (NeoCaddie/Default) ────────────────────── */

export function getSCategories(): Promise<ReturnObject<SCategory[]>> {
  return servicePost<SCategory[]>("WebGetSCategories");
}

export function createCategory(name: string, displayOrder: number): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("WebCreateCategory", {
    categoryName: name,
    order: displayOrder,
  });
}

export function saveSCategories(categories: SCategory[]): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("WebSaveSCategories", {
    category: JSON.stringify(categories),
  });
}

export function deleteSCategory(id: number): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("WebDeleteSCategory", { id });
}

/* ── Access / AIM ────────────────────────────────────── */

export function getAccessCategories(): Promise<ReturnObject<AccessCategory[]>> {
  return batchedServicePost<AccessCategory[]>("WebGetCategories");
}

export function newAccessCategory(cat: AccessCategory): Promise<ReturnObject<AccessCategory>> {
  return servicePost<AccessCategory>("WebNewAccessCategory", {
    category: cat,
  });
}

export function saveAccessCategories(categories: AccessCategory[]): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("WebSaveAccessCategories", {
    category: categories,
  });
}

export function deleteAccessCategory(id: number): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("WebDeleteAccessCategory", { category: id });
}
